import { SupplyShedFilters } from '@cibo/core'
import {
  GridColumnVisibilityModel,
  GridPaginationModel,
  GridRowSelectionModel,
} from '@mui/x-data-grid-pro'
import { Dispatch, SetStateAction, createContext } from 'react'

export const USER_SUPPLY_SHED_TABLE_PAGE_SIZES = [10, 25, 50, 100]

export interface UserSupplyShedTableState {
  // these convenience functions translate from table-row spec to resourceIds
  onDelete(): void

  gridRowSelectionModel: GridRowSelectionModel
  setGridRowSelectionModel(model: GridRowSelectionModel): void
  clearSelectedRowIds(): void

  pageSize: number
  setPageSize(pageSize: number): void
  page: number
  setPage(page: number): void
  paginationModel: GridPaginationModel
  setPaginationModel(model: GridPaginationModel): void
  columnVisibility: GridColumnVisibilityModel
  setColumnVisibility: Dispatch<SetStateAction<GridColumnVisibilityModel>>
  filters: SupplyShedFilters
  setFilters: (filters: SupplyShedFilters) => void
}

export const UserSupplyShedTableContext = createContext<UserSupplyShedTableState>({
  filters: {},
  setFilters: console.log,
  gridRowSelectionModel: { type: 'include', ids: new Set() },
  setGridRowSelectionModel: console.log,
  clearSelectedRowIds: console.log,

  onDelete: console.log,

  pageSize: USER_SUPPLY_SHED_TABLE_PAGE_SIZES[0],
  setPageSize: console.log,
  paginationModel: { pageSize: 25, page: 0 },
  setPaginationModel: console.log,
  page: 0,
  setPage: console.log,
  columnVisibility: {},
  setColumnVisibility: console.log,
})
UserSupplyShedTableContext.displayName = 'UserSupplyShedTableContext'
